import React from 'react'
import {
  FormProvider,
  useFormContext,
  UseFormReturn,
  useWatch,
} from 'react-hook-form'
import {
  NotificationRecipient,
  NotificationRecipientConfigType,
  NotificationRecipientType,
} from '../../../shared/models/notification.model'
import { Form } from 'react-bootstrap'
import Input from '../../../components/form/Input'
import Divider from '../../../components/common/Divider'

interface Props {
  form: UseFormReturn<NotificationRecipient>
}

const NotificationRecipientForm = ({ form }: Props) => {
  const { control, register } = form
  const configurationType = useWatch({
    control,
    name: 'type',
    defaultValue: NotificationRecipientType.USER,
  })
  const getSpecificForm = () => {
    switch (configurationType) {
      case NotificationRecipientType.USER:
        return <NotificationRecipientUserForm />
    }
  }
  return (
    <FormProvider {...form}>
      <Form>
        <div>
          <Input register={form.register('name')} label={'Nom'} />
          <Input
            type={'textarea'}
            register={form.register('description')}
            label={'Description'}
          />
          <Form.Label>Type de destinataire :</Form.Label>
          <Form.Group>
            <Input
              register={register('type')}
              inline={true}
              type={'radio'}
              label={'Utilisateurs de la plateforme'}
              value={NotificationRecipientType.USER}
            />
            <Input
              register={register('type')}
              type={'radio'}
              inline={true}
              value={NotificationRecipientType.SLACK}
              isDisabled={true}
              label={'Slack'}
            />
            <Input
              register={register('type')}
              type={'radio'}
              inline={true}
              isDisabled={true}
              label={'Microsoft Teams'}
              value={NotificationRecipientType.MICROSOFT_TEAMS}
            />
          </Form.Group>
        </div>
        <Divider />
        <Form.Group>{getSpecificForm()}</Form.Group>
      </Form>
    </FormProvider>
  )
}

const NotificationRecipientUserForm = () => {
  const form = useFormContext<NotificationRecipient>()
  const userFilterType = useWatch({
    control: form.control,
    name: 'configuration.type',
    defaultValue: NotificationRecipientConfigType.ALL_USERS,
  })
  React.useEffect(() => {
    form.setValue('configuration.userFilter.type', userFilterType)
  }, [userFilterType])
  return (
    <>
      <Form.Group>
        <Input
          register={form.register('configuration.type')}
          type={'select'}
          options={[
            {
              value: NotificationRecipientConfigType.ALL_USERS,
              text: 'Tous les utilisateurs',
            },
            {
              value: NotificationRecipientConfigType.AFFECTED_USER,
              text: 'Utilisateurs affectés',
            },
            {
              value: NotificationRecipientConfigType.TENANT_ADMINISTRATORS,
              text: 'Administrateurs des tenants',
            },
            {
              value:
                NotificationRecipientConfigType.ORIGINATOR_ENTITY_OWNER_USERS,
              text: "Utilisateur du propriétaire de l'entité",
            },
            {
              value:
                NotificationRecipientConfigType.AFFECTED_TENANT_ADMINISTRATORS,
              text: 'Administrateurs des tenants affectés',
            },
            {
              value: NotificationRecipientConfigType.CUSTOMER_USERS,
              text: "Utilisateurs d'un client",
            },
            {
              value: NotificationRecipientConfigType.USER_LIST,
              text: "Liste d'utilisateurs",
            },
            {
              value: NotificationRecipientConfigType.USER_GROUP_LIST,
              text: "Liste de groupe d'utilisateur",
            },
            {
              value: NotificationRecipientConfigType.SYSTEM_ADMINISTRATORS,
              text: 'Administrateurs système',
            },
          ]}
        />
        {userFilterType === NotificationRecipientConfigType.USER_LIST && (
          <UserListInput />
        )}
        {userFilterType === NotificationRecipientConfigType.CUSTOMER_USERS && (
          <CustomerUserInput />
        )}
      </Form.Group>
    </>
  )
}

const UserListInput = () => {
  const form = useFormContext<NotificationRecipient>()
  return <>USER_LIST</>
}

const CustomerUserInput = () => {
  const form = useFormContext<NotificationRecipient>()
  return <>CUSTOMER USER INPUT</>
}

export default NotificationRecipientForm
